import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { petIndexInfiniteOptions } from '$api-client/@tanstack/react-query.gen'
import { Option } from '$components'

export type InfiniteOptionsObject = {
  options: Option[],
  async: {
    fetchNextPage: () => void,
    hasNextPage: boolean,
    isLoading: boolean,
    isFetchingNextPage: boolean,
  },
  search: {
    onSearchChange: (value: string) => void,
    search: string,
  }
}

export function useInfinitePetOptions(): InfiniteOptionsObject {
  const [search, setSearch] = useState<string>('')
  const [page, setPage] = useState<number>(1)

  const { fetchNextPage, data, hasNextPage, isLoading, isFetchingNextPage } = useInfiniteQuery({
    ...petIndexInfiniteOptions({
      query: {
        query: search,
      },
    }),
    getNextPageParam: (lastPage) => lastPage.meta.current_page !== lastPage.meta.last_page ? lastPage.meta.current_page + 1 : undefined,
    initialPageParam: page,
  })

  const onSearch = (value: string) => {
    setSearch(value)
    setPage(1)
  }

  const options = data?.pages.flatMap(p => p.data.map(pet => ({ id: pet.id, value: pet.name, image: pet.image }))) ?? []

  return {
    options,
    async: {
      fetchNextPage,
      hasNextPage,
      isLoading: isLoading || isFetchingNextPage,
      isFetchingNextPage,
    },
    search: {
      onSearchChange: onSearch,
      search,
    },
  }
}
